export async function downloadCsv(response: Response, filename: string): Promise<void> {
  if (!response.ok) throw new Error(`Export failed (${response.status}).`)
  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.hidden = true
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
